export const filterObject = <T>(object: T, predicate: any) => {
  const result = {};
  const isArray = Array.isArray(predicate);

  for (const [key, value] of Object.entries(object)) {
    if (isArray ? !predicate.includes(key) : predicate(key, value, object)) {
      result[key] = value;
    }
  }

  return result;
};

export const isObject = (value: unknown) =>
  Object.prototype.toString.call(value) === Object.prototype.toString.call({});

export const isEmptyObject = (value: object) => Object.keys(value).length === 0;
